// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ChildEntities-ChildEntitiesCreators-ChildEntsAssign-ChildEntsAssign-module__drawer--cQndt .ant-drawer-body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChildEntities/ChildEntitiesCreators/ChildEntsAssign/ChildEntsAssign.module.less"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAAJ","sourcesContent":[".drawer {\n  :global(.ant-drawer-body) {\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `src-components-ChildEntities-ChildEntitiesCreators-ChildEntsAssign-ChildEntsAssign-module__drawer--cQndt`
};
export default ___CSS_LOADER_EXPORT___;
